// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1WBi8","footer":"ChangeClinic_footer__3bUJd"};